// @flow

import { componentFactory } from '../component-factory';
import { useIsMobile } from '@tectonics/hooks/use-is-mobile';

const baseStyle = {
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
  minHeight: '100%',
  width: '100%',
};

const mobileStyle = {
  ...baseStyle,
  justifyContent: 'center',
  maxWidth: '600px',
};

export const Wrapper = componentFactory('section', () => (useIsMobile() ? baseStyle :  mobileStyle));
